import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { logout } from '../../../../action/auth-actions'
import { expandRightToolbar } from '../../../../action/right-toolbar-state-actions'
import { photoUploadRequest } from '../../../../action/photo-actions'
import { userUpdateRequest } from '../../../../action/user-actions'
import { SUBSCRIPTIONS } from '../../../../lib/enums'

const Profile = props => {

  const { hidePopout, expandRightToolbar, logout, user } = props,
    userImage = user.imageProfileUrl ? user.imageProfileUrl : '../../../../asset/default-profile.png',
    basicPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 1),
    proPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 4),
    proBundlePlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 44),
    /* uncomment if global rescue and hunt data needs to be displayed on profile tab
    grPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 32), 
    huntPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 8),
    */
    updatePhoto = (e) => {
      e.preventDefault()
      inputEle.current.click()
    },
    handlePhotoUpload = (e) => {
      const { photoUploadRequest, userUpdateRequest, user } = props,
        file = e.target.files[0]
      if (file) {
        let data = new FormData()
        data.append('file', file)
        let photoInfo = {
          typeId: 2,
          activityId: 1
        }
        photoInfo = JSON.stringify(photoInfo)
        data.append('photoInfo', photoInfo)
        photoUploadRequest(data).then(res => {
          let userInfo = Object.assign({}, user)
          userInfo.photoId = res.id
          delete userInfo.password
          userUpdateRequest(userInfo)
            .then(() => {
              console.log('User Photo Updated')
            })
            .catch((err) => {
              console.error('User Photo Update Failed: ', err)
            })
        })
      }
    },
    displaySubscription = (subscriptionType) => {
      return (
        <p>{subscriptionType}</p>
      )
    },
    inputEle = React.createRef()
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly' }}>
      <div>
        <div className='popout-profile-img' style={{ backgroundImage: `url(${userImage})` }} onClick={updatePhoto}></div>
        <p style={{ textDecoration: 'underline', cursor: 'pointer', userSelect: 'none' }} onClick={updatePhoto}>Change Image</p>
        <input type='file' accept='image/*' ref={inputEle} style={{ display: 'none' }} onChange={handlePhotoUpload}></input>
      </div>
      <div>
        <div className='popout-close' onClick={hidePopout}></div>
        <p>{user.fullName}</p>
        <p>{user.email}</p>
        {
          basicPlan && !proBundlePlan && !proPlan ? (
            displaySubscription(SUBSCRIPTIONS.BASIC)
          ) : null
        }
        {
          proPlan ? (
            displaySubscription(SUBSCRIPTIONS.PRO)
          ) : null
        }
        {
          proBundlePlan ? (
            displaySubscription(SUBSCRIPTIONS.PRO_ULTIMATE)
          ) : null
        }
        {
        // TODO: uncomment if this subscription is needed on profile tab
        /* {
          grPlan ? (
            displaySubscription(SUBSCRIPTIONS.GLOBAL_RESCUE)
          ) : null
        }
        {
          huntPlan ? (
            displaySubscription(SUBSCRIPTIONS.huntPlan)
          ) : null
        } */}
        <div style={{ display: 'flex', marginTop: '20px' }}>
          <button onClick={logout}
            style={{ margin: 0, width: '125px', backgroundColor: 'gray' }}>LOG OUT</button>
          <button onClick={() => {
            expandRightToolbar({ dialog: 'profile' })
            hidePopout()
          }}
            style={{ margin: 0, marginLeft: '10px', width: '125px' }}>VIEW PROFILE</button>
        </div>
      </div>
    </div >
  )
}

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  expandRightToolbar: props => dispatch(expandRightToolbar(props)),
  photoUploadRequest: data => dispatch(photoUploadRequest(data)),
  userUpdateRequest: data => dispatch(userUpdateRequest(data)),
  logout: () => dispatch(logout())
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)